import { useEffect, useState } from "react"

import classes from './TimePickerWithLabel.module.css'
import 'react-time-picker/dist/TimePicker.css';
// import 'react-clock/dist/Clock.css';

const TimePickerWithLabel = ({label, name, action, identifier, setStyle, disabled, defaultTime}) => {
    const [isfocused, setIsFocused] = useState(false)
    const [timeValue, setTimeValue] = useState(defaultTime);

    const foucsHandler = () => {
        setIsFocused(true)
    }

    const blurHandler = (e) => {
        if (e.target.value == '') {
            setIsFocused(false)
        }    
        
        // if (e.target.value && action && e.target.value !== currentValue) {
        //     action({
        //         data: {
        //             value: e.target.value
        //         },
        //         identifier: identifier
        //     })
        // }
    }


    const handleTimeChange = (e) => {
        const time = e.target.value;

        setTimeValue(time);
        if (action) {
            action({
                data: {value: time},
                identifier: identifier
            })
        }
    }

    useEffect(() => {
        setTimeValue(defaultTime || '')
        if(defaultTime) {
            setIsFocused(true)
        } else {
            setIsFocused(false)
        }
    }, [defaultTime])
   


    return <div className={`${classes.timepicker_container} ${isfocused && classes.focused}`}>
        <label htmlFor={name} className={classes.label}>{label}</label>
        <input className={classes.input} name={name} id={name} type="time" value={timeValue} onChange={handleTimeChange} onFocus={foucsHandler} onBlur={blurHandler} step="600" disabled={disabled}/>
    </div>
}

export default TimePickerWithLabel